let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("gtMen"), load("hhss7"), load("ffEVr"), load("1NKZf")]).then(() => parcelRequire('byS2e'));